export const LIST_CUSTOMER_LOAN = 'LIST_CUSTOMER_LOAN';
export const STORE_CUSTOMER_LOAN = 'STORE_CUSTOMER_LOAN';
export const SAVE_CUSTOMER_LOAN = 'SAVE_CUSTOMER_LOAN';

export const LIST_EMPLOYEE_LOAN = 'LIST_EMPLOYEE_LOAN';
export const STORE_EMPLOYEE_LOAN = 'STORE_EMPLOYEE_LOAN';
export const SAVE_EMPLOYEE_LOAN = 'SAVE_EMPLOYEE_LOAN';


export const LIST_ZELLE_LOAN = 'LIST_ZELLE_LOAN';
export const STORE_ZELLE_LOAN = 'STORE_ZELLE_LOAN';
export const SAVE_ZELLE_LOAN = 'SAVE_ZELLE_LOAN';
